var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbupDoubleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6523 19.1667H24.9023C25.263 19.1667 25.6139 19.0497 25.9023 18.8333C26.1908 18.617 26.4014 18.3129 26.5023 17.9667L28.444 11.3C28.5165 11.0516 28.5301 10.7898 28.4838 10.5352C28.4375 10.2806 28.3326 10.0403 28.1773 9.83333C28.0221 9.62634 27.8208 9.45833 27.5894 9.34262C27.3579 9.22691 27.1028 9.16667 26.844 9.16667H21.9857L22.819 5.73333C22.9132 5.35178 22.92 4.95387 22.8388 4.56933C22.7576 4.1848 22.5906 3.82358 22.3502 3.51267C22.1098 3.20176 21.8022 2.94919 21.4505 2.77383C21.0988 2.59847 20.712 2.50487 20.319 2.5L17.444 8.24167C17.306 8.51934 17.0933 8.75302 16.8298 8.91643C16.5663 9.07984 16.2624 9.1665 15.9523 9.16667H13.6523",
    stroke: "#2D211C",
    strokeWidth: 1.99943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8187 5.73333L12.9854 9.16667H17.8437C18.1024 9.16667 18.3576 9.22691 18.589 9.34262C18.8205 9.45833 19.0218 9.62634 19.177 9.83333C19.3323 10.0403 19.4372 10.2806 19.4835 10.5352C19.5298 10.7898 19.5161 11.0516 19.4437 11.3L17.502 17.9667C17.401 18.3129 17.1905 18.617 16.902 18.8333C16.6135 19.0497 16.2626 19.1667 15.902 19.1667H4.65202C4.20999 19.1667 3.78607 18.9911 3.47351 18.6785C3.16095 18.366 2.98535 17.942 2.98535 17.5V10.8333C2.98535 10.3913 3.16095 9.96738 3.47351 9.65482C3.78607 9.34226 4.20999 9.16667 4.65202 9.16667H6.95202C7.26209 9.1665 7.56596 9.07984 7.82948 8.91643C8.093 8.75302 8.3057 8.51934 8.44369 8.24167L11.3187 2.5C11.7117 2.50487 12.0985 2.59847 12.4502 2.77383C12.8019 2.94919 13.1095 3.20176 13.3499 3.51267C13.5903 3.82358 13.7573 4.1848 13.8385 4.56933C13.9196 4.95387 13.9129 5.35178 13.8187 5.73333Z",
    stroke: "#2D211C",
    strokeWidth: 1.99943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98535 9.5L6.98535 18.5",
    stroke: "#2D211C",
    strokeWidth: 1.99943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbupDoubleIcon);
export default __webpack_public_path__ + "static/media/thumbup-double-icon.c061aeb4d8139bcbfb8d3422973c6e4e.svg";
export { ForwardRef as ReactComponent };